import "react-admin-base-adminkit/assets/app.css";
import 'react-admin-base-bootstrap/assets/main.css';
import './assets/App.scss';
import 'react-aspect-ratio/aspect-ratio.css';

import {App as BaseApp, Authorized, AuthProvider, ForgotPasswordRoute, LoginRoute, NotAuthorized, RegisterRoute} from 'react-admin-base';
import {UserProvider} from "./Components/UserProvider";
import UploadConfig from "./UploadConfig";
import Landing from "./start/Landing";
import {BrowserRouter, Route} from "react-router-dom";
import Register from "./start/Register";
import ProfileGuard from "./profile/ProfileGuard";
import AppLogo from './assets/images/logo.png';
import Home from "./Home";
import LanguageProvider from "./i18n";
import Login from "./start/Login";
import { Reset } from "react-admin-base-adminkit";

export default function App() {
    return (
        <BrowserRouter>
            <BaseApp
                id="mentorup"
                name="MentorUp"
                endpoint={process.env.REACT_APP_ENDPOINT}
                logo={AppLogo}
            >
                <LanguageProvider>
                    <AuthProvider
                        tokenEndpoint="/token"
                        client_id="3da4385d-5166-4c1f-9c4b-49afe82be47e"
                        client_secret="123456"
                    >
                        <NotAuthorized>
                            <Route exact path="/" component={Landing} />
                            <LoginRoute>
                                <Login/>
                            </LoginRoute>
                            <ForgotPasswordRoute>
                                <Reset/>
                            </ForgotPasswordRoute>
                            <RegisterRoute>
                                <Register />
                            </RegisterRoute>
                        </NotAuthorized>
                        <Authorized>
                            <UserProvider>
                                <UploadConfig>
                                    <ProfileGuard>
                                        <Home />
                                    </ProfileGuard>
                                </UploadConfig>
                            </UserProvider>
                        </Authorized>
                    </AuthProvider>
                </LanguageProvider>
            </BaseApp>
        </BrowserRouter>
    );
}

